import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Row from "./row";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ability } from "../../../config/acl/ability";
import * as XLSX from 'xlsx';
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { FaFileExcel } from "react-icons/fa";
import {Can} from "../../Can";

const DataTableByOffer = ({
  setOrderOption,
  setData,
  data,
  rowsPerPage,
  currentPage,
  filters
}) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [exportLoading, setExportLoading] = useState(false);
  const canReviewOrder = ability.can('order', 'review');

  // Handle sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] === null || b[orderBy] === null) return 0; // Null-safe comparison
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Offers Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "ID",
          "Offer Name",
          "User Name",
          "Reseller",
          "Price",
          "Panel URL",
          "Payment Method",
          "Created At",
          "Status Payment",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item.request_id || "N/A",
        item.offerName || "N/A",
        item.user_name || "N/A",
        item.reseller || "N/A",
        item.price || "N/A",
        item.panel_url || "N/A",
        item.payment_method || "N/A",
        item.created_at || "N/A",
        item.status_payment || "N/A",
        item.status || "N/A",
      ]),
    });
    doc.save("offersTable.pdf");
  };

  const exportToExcel = async () => {
    setExportLoading(true);
    try {
      // Build query string from filters
      const queryParams = [];
      if (filters.dateRange.start && filters.dateRange.end) {
        queryParams.push(`start_date=${filters.dateRange.start.toISOString().split("T")[0]}`);
        queryParams.push(`end_date=${filters.dateRange.end.toISOString().split("T")[0]}`);
      } else if (filters.dateRange.end) {
        queryParams.push(`end_date=${filters.dateRange.end.toISOString().split("T")[0]}`);
      }
      if (filters.orderStatus && filters.orderStatus !== "null") {
        queryParams.push(`order_status=${filters.orderStatus}`);
      }
      if (filters.paymentStatus && filters.paymentStatus !== "null") {
        queryParams.push(`payment_status=${filters.paymentStatus}`);
      }
      if (filters.source && filters.source !== "null") {
        queryParams.push(`source=${filters.source}`);
      }
      if (filters.panelUrl) {
        queryParams.push(`panel_url=${encodeURIComponent(filters.panelUrl)}`);
      }

      const queryString = queryParams.length ? `${queryParams.join("&")}` : "";
      const url = `${api_Routes.Orders.ExportByOffers}?${queryString}`;

      const { response, message } = await Helper.Get({
        url,
        hasToken: true,
      });

      if (response) {
        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(
            response.data.map(item => ({
              ID: item.request_id || "N/A",
              'Offer Name': item.offerName || "N/A",
              'User Name': item.user_name || "N/A",
              Reseller: item.reseller || "N/A",
              Price: item.price || "N/A",
              Discount: item.discount || 0,
              "Net Price": item.price - item.discount || 0,
              'Panel URL': item.panel_url || "N/A",
              'Payment Method': item.payment_method || "N/A",
              'Created At': item.created_at || "N/A",
              'Created By': item.created_By || "N/A",
              'Payment Status': item.status_payment || "N/A",
              Status: item.status || "N/A",
            }))
        );

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Offers");
        XLSX.writeFile(workbook, `Offers_Export_${new Date().toISOString().split('T')[0]}.xlsx`);
      } else {
        throw new Error(message || 'Failed to export data');
      }

    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export data. Please try again.');
    } finally {
      setExportLoading(false);
    }
  };
  ////
  return (
    <>
      <Can I={'export'} a={'orders'}>
      <div className="flex gap-2 mb-3">
        {/*<button*/}
        {/*    onClick={exportPDF}*/}
        {/*    className="bg-primary text-white p-2 rounded flex items-center gap-2"*/}
        {/*>*/}
        {/*  Export to PDF*/}
        {/*</button>*/}

        <button
            onClick={exportToExcel}
            disabled={exportLoading}
            className="bg-green-600 text-white p-2 rounded flex items-center gap-2 disabled:opacity-50"
        >
          <FaFileExcel />
          {exportLoading ? 'Exporting...' : 'Export to Excel'}
        </button>
      </div>
      </Can>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              <TableCell
                align="center"
                sx={{
                  backgroundColor: "primary.main",
                  color: "white",
                  fontWeight: "bold",
                }}
              />

              {[
                { label: " offer ID", key: "request_id" },
                { label: "Offer Name", key: "offerName" },
                { label: "User Name", key: "user_name" },
                { label: "Reseller", key: "reseller" },
                { label: "Price", key: "price" },
                { label: "Discount", key: "discount" },
                { label: "Net Price", key: "price" },
                { label: "Panel URL", key: null },
                { label: "Created At", key: "created_at" },
                { label: "Created By", key: "created_By" },
                { label: "Status Payment", key: "status_payment" },
                { label: "Status", key: "status" },
                { label: "Action", key: "action" },
                // canReviewOrder ? { label: "Review", key: "review" } : {},
              ].map((column) => (
                <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  key={column.label}
                  onClick={
                    column.key ? () => handleSort(column.key) : undefined
                  }
                  style={{ cursor: column.key ? "pointer" : "default" }}
                >
                  {column.label}
                  {column.key &&
                    (orderBy === column.key ? (
                      order === "asc" ? (
                        <span> ▲</span>
                      ) : (
                        <span> ▼</span>
                      )
                    ) : (
                      ""
                    ))}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <Row
                setOrderOption={setOrderOption}
                key={item.id}
                item={item}
                setData={setData}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTableByOffer;
